import { useFormikContext } from 'formik';
import { ContactLibrary } from 'app/domains/esigning/components/ContactLibrary';
import { EsigningRecipientType } from 'shared/domains/apollo/generated/types';
export function Contacts(props) {
    const { onSelect } = props;
    const { setValues } = useFormikContext();
    const handleSelect = (contact) => {
        var _a, _b, _c, _d, _e, _f, _g;
        setValues({
            firstName: (_a = contact.firstName) !== null && _a !== void 0 ? _a : '',
            lastName: (_b = contact.lastName) !== null && _b !== void 0 ? _b : '',
            email: (_c = contact.email) !== null && _c !== void 0 ? _c : '',
            mobile: (_d = contact.mobile) !== null && _d !== void 0 ? _d : '',
            label: (_e = contact.label) !== null && _e !== void 0 ? _e : '',
            title: (_f = contact.title) !== null && _f !== void 0 ? _f : '',
            type: EsigningRecipientType.Signatory,
            authenticationMode: (_g = contact.authenticationMode) !== null && _g !== void 0 ? _g : undefined,
        });
        onSelect();
    };
    return <ContactLibrary onSelect={handleSelect}/>;
}
